/** Animated scroll-down indicator for the portfolio page. */
export default function ScrollIcon() {
  return (
    <a className="mouse-scroll hidden-xs" href="#">
      <span className="mouse">
        <span className="mouse-movement"></span>
      </span>
    </a>
  );
}
